// CMS-Service für Interpreten (Artists) — Admin-Endpoints /api/admin/artists.
// Auth-Muster identisch zu albumService (eigene axios-Instanz + Bearer aus der Supabase-Session).
import axios, { AxiosInstance } from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';
import { getAccessToken } from '../lib/authToken';
import { Artist, CreateArtistInput, UpdateArtistInput } from '../types/artist';

class ArtistService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: getApiBaseUrl(),
      timeout: 15000,
      headers: { 'Content-Type': 'application/json' },
    });
    this.api.interceptors.request.use(async (config) => {
      const token = await getAccessToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  }

  async getArtists(): Promise<Artist[]> {
    const res = await this.api.get<{ data: Artist[] }>('/api/admin/artists');
    return res.data.data ?? [];
  }

  async getArtistById(id: string): Promise<Artist> {
    const res = await this.api.get<{ data: Artist }>(`/api/admin/artists/${id}`);
    return res.data.data;
  }

  async createArtist(input: CreateArtistInput): Promise<Artist> {
    const res = await this.api.post<{ data: Artist }>('/api/admin/artists', input);
    return res.data.data;
  }

  async updateArtist(id: string, input: UpdateArtistInput): Promise<Artist> {
    const res = await this.api.patch<{ data: Artist }>(`/api/admin/artists/${id}`, input);
    return res.data.data;
  }

  async deleteArtist(id: string): Promise<void> {
    await this.api.delete(`/api/admin/artists/${id}`);
  }

  // ⚠️ Hier stand `uploadImage(file)` — der Aufruf von `POST /api/admin/artists/upload-image`.
  // Entfallen am 2026-09-08 (Tom-Entscheid: die CMS-Aufrufer der Uploads gehen, der Ingest
  // uebernimmt; `ingestGeteilteBilder.ts` schreibt `artists.profileImageUrl`). ⛔ Die Route
  // SELBST steht noch — sie abzuraeumen ist 🌐s Zug, in dieser Reihenfolge: erst der Aufrufer,
  // dann die Route. Wer den Upload wiederhaben will, baut nicht diese Zeile nach, sondern klaert
  // zuerst, warum der Ingest nicht reicht.
}

export const artistService = new ArtistService();
